import type { Template } from "@/types";

export const MFP: Template[] = [
    {
        id: "mf-01",
        name: "NEWBORN",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/newborn.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 73, y: 127, width: 390, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 468, y: 127, width: 390, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 863, y: 127, width: 390, height: 283, rotation: 0, imageRotation: 0 }
        ],
        texts: [
            { id: "26095df8-b4aa-40bf-9798-5ead4c79eff7", text: "Imogen Mae Haverfield", x: 480, y: 537, width: 368, fontSize: 22, fontFamily: "Book Antiqua", fontWeight: "normal", align: "center", rotation: 0, fill: "#67412d", opacity: 1, strokeWidth: 2, shadowColor: "#000000" },
            { id: "d45992bb-a5b7-4dc3-833a-6f5fc799ca37", text: "November 05, 2026 | 3.46am | 8 lbs 7oz | 19 in", x: 442, y: 563, width: 443, fontSize: 15, fontFamily: "Arial", fontWeight: "normal", align: "center", rotation: 0, fill: "#67412d", opacity: 1, strokeWidth: 2, shadowColor: "#000000" },
        ],
    },

    {
        id: "mf-02",
        name: "ANNANDALE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/annandale.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 72, y: 63, width: 157, height: 237, rotation: 0, imageRotation: 0 },
            { id: "2", x: 72, y: 307, width: 409, height: 291, rotation: 0, imageRotation: 0 },          
            { id: "3", x: 236, y: 63, width: 245, height: 237, rotation: 0, imageRotation: 0 },
            { id: "5", x: 488, y: 63, width: 350, height: 535, rotation: 0, imageRotation: 0 },
            { id: "5", x: 845, y: 63, width: 410, height: 291, rotation: 0, imageRotation: 0 },
            { id: "6", x: 845, y: 361, width: 246, height: 237, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1098, y: 361, width: 157, height: 237, rotation: 0, imageRotation: 0 }
        ],         
    },

    {
        id: "MF-03",
        name: "BELMORE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/belmore.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 69, y: 63, width: 813, height: 537, rotation: 0, imageRotation: 0 },
            { id: "2", x: 889, y: 63, width: 368, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 889, y: 326, width: 181, height: 274, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1077, y: 326, width: 180, height: 274, rotation: 0, imageRotation: 0 }
       
        ],         
    },

    {
        id: "MF-04",
        name: "BONDI",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/bondi.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 367, y: 63, width: 606, height: 537, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 63, width: 291, height: 265, rotation: 0, imageRotation: 0 },
            { id: "3", x: 69, y: 335, width: 291, height: 265, rotation: 0, imageRotation: 0 },
            { id: "4", x: 980, y: 63, width: 277, height: 265, rotation: 0, imageRotation: 0 },
            { id: "5", x: 980, y: 335, width: 277, height: 265, rotation: 0, imageRotation: 0 }
        ],     
    },

    {
        id: "MF-05",
        name: "CRONULLA",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/cronulla.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 453, y: 60, width: 420, height: 542, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 60, width: 380, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 66, y: 335, width: 380, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 880, y: 60, width: 379, height: 268, rotation: 0, imageRotation: 0 },
            { id: "5", x: 880, y: 335, width: 379, height: 267, rotation: 0, imageRotation: 0 }
        ],   
    },


    {
        id: "MF-06",
        name: "EARLWOOD",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/earlwood.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 254, y: 64, width: 818, height: 533, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 64, width: 176, height: 263, rotation: 0, imageRotation: 0 },
            { id: "3", x: 71, y: 334, width: 176, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1079, y: 64, width: 176, height: 263, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 334, width: 176, height: 263, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "MF-07",
        name: "HEATHCOTE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/heathcote.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 71, y: 64, width: 918, height: 533, rotation: 0, imageRotation: 0 },
            { id: "2", x: 996, y: 64, width: 259, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 996, y: 244, width: 259, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 996, y: 424, width: 259, height: 173, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "MF-08",
        name: "NEWPORT",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/newport.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 79, y: 70, width: 777, height: 522, rotation: 0, imageRotation: 0 },
            { id: "2", x: 863, y: 70, width: 384, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 863, y: 335, width: 384, height: 257, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "MF-09",
        name: "OAKHURST",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/oakhurst.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 75, y: 69, width: 990, height: 525, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1072, y: 69, width: 179, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1072, y: 335, width: 179, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "MF-10",
        name: "STANMORE",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/stanmore.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 70, y: 62, width: 391, height: 537, rotation: 0, imageRotation: 0 },
            { id: "2", x: 468, y: 62, width: 391, height: 537, rotation: 0, imageRotation: 0 },
            { id: "3", x: 866, y: 62, width: 390, height: 537, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "MF-11",
        name: "THORNLEIGH",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/thornleigh.png",
        size: [1324, 662],
        style: {},
        slots: [
            { id: "1", x: 70, y: 62, width: 324, height: 537, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 401, y: 62, width: 522, height: 537, rotation: 0, imageRotation: 0 },
            { id: "3", x: 930, y: 62, width: 326, height: 537, rotation: 0, imageRotation: 0 }
        ],

    },

    {
        id: "MF-12",
        name: "VILLAWOOD",
        albumType: "MF",
        thumbnail: "/thumbnails/MF/AR_2.00/villawood.png",
        size: [1324, 662],
        style: {},
        slots: [         
            { id: "1", x: 72, y: 68, width: 824, height: 525, rotation: 0, imageRotation: 0 },
            { id: "2", x: 903, y: 68, width: 351, height: 525, rotation: 0, imageRotation: 0 }
        ],

    },
];
